export var NOT_FOUND = -1;
export var SESSION_CHECK_TIME = 1000 * 60 * 10;